import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import RelatedProductsOrganism from '~/components/_next/organisms/RelatedProductsOrganism.vue';
import RelatedRecipesOrganism from '~/components/_next/organisms/RelatedRecipesOrganism.vue';
import RelatedAdvicesOrganism from '~/components/_next/organisms/RelatedAdvicesOrganism.vue';
import { useSearchUpsell } from '~/composables/_next/stores/useSearchUpsell';
export default /*#__PURE__*/_defineComponent({
  __name: 'searchUpsell',
  props: {
    kind: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useSearchUpsell = useSearchUpsell(),
      relatedRecipes = _useSearchUpsell.relatedRecipes,
      searchAssociatedProductRecipeAdvice = _useSearchUpsell.searchAssociatedProductRecipeAdvice,
      relatedProductsSku = _useSearchUpsell.relatedProductsSku,
      relatedAdvices = _useSearchUpsell.relatedAdvices;
    var _useLazyAsyncData = useLazyAsyncData("fetch-search-upsell", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return searchAssociatedProductRecipeAdvice();
            case 2:
              return _context.abrupt("return", true);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))),
      contentLoading = _useLazyAsyncData.pending;
    return {
      __sfc: true,
      props: props,
      relatedRecipes: relatedRecipes,
      searchAssociatedProductRecipeAdvice: searchAssociatedProductRecipeAdvice,
      relatedProductsSku: relatedProductsSku,
      relatedAdvices: relatedAdvices,
      contentLoading: contentLoading,
      RelatedProductsOrganism: RelatedProductsOrganism,
      RelatedRecipesOrganism: RelatedRecipesOrganism,
      RelatedAdvicesOrganism: RelatedAdvicesOrganism
    };
  }
});